// eslint-disable-next-line import/named
import { State } from '@hookstate/core'

export function setValue<T>(state: State<T>) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  return (e: React.ChangeEvent<unknown>, _child: React.ReactNode) =>
    state.set(e.target.value)
}
